import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import Notice from '../notices/Notice';
import HeaderComponent from '../HeaderComponent';
import LoadingComponent from '../LoadingComponent';
import LoadMore from '../LoadMore';

import css from '../../styles/notices/notices';

class Notices extends Component {
    static propTypes = {
        symbol: PropTypes.string,
        notices: PropTypes.array,
        isLoading: PropTypes.bool,
        requestNoticesData: PropTypes.func,
        t: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.limit = 3;

        this._fetchMore = () => {
            this.limit += 5;
            this.props.requestNoticesData(this.props.symbol, this.limit);
        };
    }

    renderContent() {
        const { notices } = this.props;

        if (this.props.notices.length < 1) {
            return <LoadingComponent height={250} />;
        }

        return (
            <div className={css.notices}>
                {notices.map(notice =>
                    <Notice {...notice} key={notice.REFERENCEID} />)
                }
                <div className={css.loadWrapper}>
                    <LoadMore
                        onClick={this._fetchMore}
                        loading={this.props.isLoading}
                    />
                </div>
            </div>
        );
    }

    render() {
        if (!this.props.isLoading && this.props.notices.length < 1) {
            return null;
        }

        return (
            <HeaderComponent title={ this.props.t('announcements') }>
                {this.renderContent()}
            </HeaderComponent>
        );
    }
}

export default translate('stocks')(Notices);



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/Notices.js
 **/